import React, { memo } from 'react';
import { withNativeProps } from '../../utils/native-props';
export var FallbackIcon = /*#__PURE__*/memo(function (props) {
  return withNativeProps(props, /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3H3V21H13.2933L14.7933 19.5H9C9 14.5294 13.0294 10.5 18 10.5C18.5111 10.5 19.0122 10.5426 19.5 10.6244V14.7934L21 13.2934V3ZM9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75ZM20.4147 15.4343L21.5657 16.5853L19.651 18.5L21.5657 20.4147L20.4147 21.5657L18.5 19.651L16.5853 21.5657L15.4343 20.4147L17.349 18.5L15.4343 16.5853L16.5853 15.4343L18.5 17.349L20.4147 15.4343Z"
  })));
});